import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
// L12 : la flotte et le client (ses avions, le serveur filtre — I5) ; l'inspecteur lit tout.
export const MaintenanceDefectRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet', 'role--maintenance--client']}>
    <Route path='file/:defectId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
